export const hero = [
    {
        "title": "Elevate Your Style with High-Quality Clothing from QueenTouch",
        "description": "Discover our wide range of clothing options for men, women, and children. Made from 100% pure denim, our garments are both durable and comfortable. Shop with us now and take your wardrobe to the next level.",
        "cta": "Shop Now"
    },
    {
        "title": "Find Your Perfect Fit at QueenTouch",
        "description": "From classic cuts to on-trend styles, we have something for everyone. Our clothing is made with attention to detail and a focus on comfort, so you can look and feel your best. Shop with us today and discover your new favorite outfit.",
        "cta": "Browse Our Collection"
    },
    {
        "title": "Experience the Quality and Style of QueenTouch",
        "description": "At QueenTouch, we are committed to providing our customers with the best possible shopping experience. From the moment you visit our website, you will be greeted with a wide selection of fashionable and stylish clothing options for all genders. Shop with us now and see the difference for yourself.",
        "cta": "Start Shopping"

    },
    {
        "title": "Stay Ahead of the Trends with QueenTouch Clothing",
        "description": "From casual everyday wear to formal occasion dresses, we have the latest styles for every mood and occasion. Our clothing is made with quality materials and attention to detail, ensuring that you always look and feel your best. Shop with us now and stay ahead of the curve.",
        "cta": "Shop New Arrivals"
    },
    {
        "title": "Get the Best Value for Your Money at QueenTouch",
        "description": "We believe that high-quality clothing doesn't have to break the bank. That's why we offer a wide range of affordable options for men, women, and children. Shop with us and discover the best value for your money.",
        "cta": "View Our Deals"
    },
    {
        "title": "Join the QueenTouch Community and Get Exclusive Benefits",
        "description": "When you shop with us, you're not just getting great clothing - you're joining a community of fashion-forward individuals who love quality and style. As a member of the QueenTouch community, you'll get access to exclusive discounts, early access to new products, and much more. Sign up now and start enjoying the benefits.",
        "cta": "Join Now"
    },
    {
        "title": "Shop the Best in Quality and Style at QueenTouch",
        "description": "Our clothing is made with the finest materials and attention to detail, ensuring that you always look and feel your best. From casual wear to formal attire, we have something for every occasion. Shop with us now and experience the difference for yourself.",
        "cta": "Shop Now"
    },
        {
        "title": "Find Your Perfect Outfit at QueenTouch",
        "description": "With a wide range of styles and sizes to choose from, we have something for everyone. Our clothing is made with comfort and durability in mind, so you can feel confident and comfortable all day long. Shop with us now and find your perfect outfit.",
        "cta": "Browse Our Collection"
    },
    {
        "title": "Discover the Best in Fashion at QueenTouch",
        "description": "From classic cuts to on-trend styles, we have the latest and greatest in fashion. Our clothing is made with quality materials and attention to detail, ensuring that you always look and feel your best. Shop with us now and discover the best in fashion.",
        "cta": "Shop Now"
    },
]
  

export const Categoris = [
    {
        id: 1,
        cat: "jewelery",
        img: "https://media.istockphoto.com/photos/elegant-jewelry-set-of-white-gold-ring-necklace-and-earrings-with-picture-id1216928523?b=1&k=20&m=1216928523&s=612x612&w=0&h=Gw14mYpKwp24oaX2O03m7W83v6p5_Y_hnfa2tKbQtLs=",
        title: "jewelery",
        
    },
    {
        id: 2,
        cat: "clotiong",
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQPD8NKQTHTsZ6HnOE52Ghjg9QqwzsP_NiZYg&usqp=CAU",
        title: "clothing",
        
    },
    {
        id: 3,
        cat: "bottom",
        img: "https://png.pngtree.com/png-clipart/20190920/original/pngtree-technology-product-office-computer-png-image_4642139.jpg",
        title: "bottom's",
        
    },
    
]
